// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"92":"cb2e61cc2a41f07f","822":"32a79c755dd6f7dd"}[chunkId] + "";
};